// Select the member opening before first paint. No auth state is written here.
var lihMemberFirstName = '';
try {
  if (localStorage.getItem('publicAuthToken')) {
    document.documentElement.classList.add('member-session');
    // Same precedence member-home.js lands on once the API answers, so the
    // pre-paint name matches the final one instead of trading one flip for
    // another (a Discord display_name is often nothing like a first name).
    var cached = JSON.parse(localStorage.getItem('public_auth_user') || 'null');
    lihMemberFirstName = (cached && (cached.first_name || '').trim()) ||
      (cached && (cached.display_name || '').trim().split(/\s+/)[0]) ||
      (cached && cached.username) || '';
  }
} catch { /* Visitors can still use the complete public homepage. */ }

// Called by a one-liner right after the greeting markup, so a returning member's
// name is in the heading as it parses instead of "HEY, TEAMMATE." flipping over
// once the member-home module boots. member-home.js still sets the name from the
// API response; this only covers the gap before that lands.
window.lihGreetMember = function (node) {
  if (node && lihMemberFirstName) node.textContent = lihMemberFirstName;
};
